import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { fetchEntryPoints } from '@/services/tracking-link';
import { EntryLinkDialog } from '@/components/dialog/entry-link-dialog';
import { EntryLinkListDialog } from '@/components/dialog/entry-link-list-dialog';
import { LinkIcon } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { QrCustomizeDialog } from '@/components/dialog/qr-customize-Dialog';
export const TrackingLinkEntryPoints = ({ trackingLink }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: entryPoints = [] } = useQuery({
        queryKey: ['tracking-link-entry-points', trackingLink.publicId],
        queryFn: () => fetchEntryPoints(trackingLink.publicId),
        enabled: !!trackingLink.publicId,
    });
    const handleSuccess = React.useCallback(() => {
        queryClient.invalidateQueries({ queryKey: ['tracking-link-entry-points', trackingLink.publicId] });
    }, [trackingLink.publicId, queryClient]);
    const defaultEp = React.useMemo(() => entryPoints.find((ep) => ep.isDefault) ?? entryPoints[0], [entryPoints]);
    const handleCopy = React.useCallback((entryPoint) => navigator.clipboard
        .writeText(entryPoint.publicUrl)
        .then(() => toast.success(t('copied_clipboard')))
        .catch(() => toast.error(t('copy_failed', { ns: 'error' }))), [t]);
    return (<div className="space-y-3">
            {defaultEp && (<React.Fragment>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button variant="ghost" size="sm" onClick={() => handleCopy(defaultEp)}>
                                <LinkIcon />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p> {t('copy_default_link')}</p>
                        </TooltipContent>
                    </Tooltip>
                    <QrCustomizeDialog entryPoint={defaultEp} isIcon/>
                </React.Fragment>)}

            <EntryLinkListDialog entryPoints={entryPoints} onCopy={handleCopy} onSuccess={handleSuccess} isIcon/>
            <EntryLinkDialog trackingLink={trackingLink} onSuccess={handleSuccess} isIcon/>
        </div>);
};
TrackingLinkEntryPoints.displayName = 'TrackingLinkEntryPoints';
